export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';

export const UPDATE_AUTH_USER = 'update_auth_user';
export const UPDATE_LOAD_USER = 'update_load_user';
export const SEND_FORGET_PASSWORD_EMAIL = 'send_forget_password_email';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';

export const SET_DASHBOARD_DATA = 'set_dashboard_data';

export const SET_TASK_CURRENT_USER = 'set_task_current_user';
export const SET_TASKS_DATA = 'set_tasks_data';
export const SET_TASK_LIST_DATA = 'set_task_list_data';
export const ADD_TASK = 'add_task';
export const DELETE_TASK = 'delete_task';
export const UPDATE_TASK = 'update_task';
export const SET_FILTER_DATA = 'set_filter_data';
export const ADD_TASK_LIST = 'add_task_list';
export const UPDATE_TASK_LIST = 'update_task_list';
export const DELETE_TASK_LIST = 'delete_task_list';
export const SET_TASK_DETAIL = 'set_task_detail';
export const SEND_MESSAGE = 'send_message';
export const TOGGLE_SIDEBAR_COLLAPSED = 'toggle_sidebar_collapsed';
export const GET_TASKS_COUNTS = 'get_tasks_counts';

//mail app
export const GET_LABELS_LIST = 'get_labels_list';
export const GET_CONNECTIONS_LIST = 'get_connections_list';
export const GET_MAILS_LIST = 'get_mails_list';
export const UPDATE_MAIL_FOLDER = 'update_mail_folder';
export const UPDATE_MAIL_LABEL = 'upade_mail_label';
export const UPDATE_FAVORITE_STATUS = 'update_favorite_status';
export const UPDATE_READ_STATUS = 'update_read_status';
export const UPDATE_IMPORTANT_STATUS = 'update_important_status';
export const COMPOSE_MAIL = 'compose_mail';
export const SET_FILTER_TYPE = 'set_filter_type';
export const GET_SELECTED_MAIL = 'GET_SELECTED_MAIL';
export const UPDATE_SELECTED_MAIL = 'update_selected_mail';
export const NULLIFY_SELECTED_MAIL = 'nullify_selected_mail';
export const REPLY_TO_MAIL = 'reply_to_mail';
export const GET_MAIL_COUNTS = 'get_mail_count';
export const ADD_LABEL = 'add_label';
export const ADD_CONNECTION = 'add_connection';
export const REMOVE_CONNECTION = 'remove_connection';

export const SET_CHAT_USERS = 'set_chat_users';
export const SET_CONTACT_USERS = 'set_contact_users';
export const SET_CURRENT_USER = 'set_current_user';
export const SET_CONVERSATION_DATA = 'set_conversation_data';
export const SEND_NEW_CHAT_MESSAGE = 'send_new_chat_message';
export const SEND_NEW_MEDIA_MESSAGE = 'send_new_media_message';

//Download App
export const GET_DOWNLOADS_LIST = 'get_downloads_list';
export const GET_DOWNLOADS_INFINITE_LIST = 'GET_DOWNLOADS_INFINITE_LIST';
export const RESET_DOWNLOADS_INFINITE_LIST = 'RESET_DOWNLOADS_INFINITE_LIST';
export const SET_CURRENT_MOVIE = 'set_current_movie';
export const GET_CURRENT_MOVIE = 'get_current_movie';
export const UPDATE_PRODUCT_TYPE = 'update_product_type';

export const CLEAR_CURRENT_MOVIE = 'clear_current_movie';
export const CLEAR_CURRENT_DOWNLOAD_ITEM = 'clear_current_download_item';
export const SET_FILTER_BUNDLE = 'set_filter_bundle';

export const CREATE_CONTACT = 'create_contact';
export const UPDATE_STARRED_STATUS = 'update_starred_status';
export const DELETE_CONTACT = 'delete_contact';
export const UPDATE_CONTACT_LABEL = 'update_contact_label';
export const UPDATE_CONTACT = 'update_contact';
export const GET_CONTACT_COUNTS = 'get_contact_counts';
export const UPDATE_LABEL_ITEM = 'update_label_item';
export const DELETE_LABEL_ITEM = 'delete_label_item';

export const GET_USER_DETAIL = 'get_user_detail';
export const GET_FEED_POSTS = 'get_feed_posts';
export const CREATE_POST = 'create_post';
export const UPDATE_POST = 'update_post';

export const CREATE_DOWNLOAD = 'create_download';
export const UPDATE_DOWNLOAD = 'update_download';
export const GET_DOWNLOAD = 'get_download';
export const DOWNLOAD_IS_CREATED = 'download_is_created';

export const GENERATE_FREE_DOWNLOAD_ITEM = 'GENERATE_FREE_DOWNLOAD_ITEM';
export const CREATE_DOWNLOAD_ITEM = 'create_download_item';
export const UPDATE_DOWNLOAD_ITEM = 'update_download_item';
export const DELETE_DOWNLOAD_ITEM = 'delete_download_item';
export const GET_DOWNLOAD_ITEM = 'get_download_item';
export const GET_DOWNLOAD_ITEM_LIST = 'get_download_item_list';

export const CREATE_BUNDLE = 'create_bundle';
export const UPDATE_BUNDLE = 'update_bundle';
export const DELETE_BUNDLE = 'delete_bundle';
export const GET_BUNDLE = 'get_bundle';
export const GET_BUNDLE_ITEM_MOVIE = 'get_bundle_item_movie';

export const GET_COMPANIES_LIST = 'get_companies_list';
export const GET_COMPANY = 'get_company';

// Users Module
export const GET_USERS = 'GET_USERS';
export const ADD_USER = 'ADD_USER';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_BULK_USERS = 'DELETE_BULK_USERS';

// Realtion Module
export const GET_RELATIONS = 'GET_RELATIONS';
export const ADD_RELATION = 'ADD_RELATION';
export const DELETE_RELATION = 'DELETE_RELATION';
export const EDIT_RELATION = 'EDIT_RELATION';
export const GET_CURRENT_RELATION = 'GET_CURRENT_RELATION';
export const CLEAR_CURRENT_RLATION = 'CLEAR_CURRENT_RLATION';

// Critics Module
export const GET_SHORT_CRITIC = 'GET_SHORT_CRITIC';
export const GET_SHORT_CRITIC_LIST = 'GET_SHORT_CRITIC_LIST';
export const ADD_SHORT_CRITIC = 'ADD_SHORT_CRITIC';
export const UPDATE_SHORT_CRITIC = 'UPDATE_SHORT_CRITIC';
export const REMOVE_SHORT_CRITIC = 'REMOVE_SHORT_CRITIC';

// News Module
export const GET_NEWS_LIST = 'GET_NEWS_LIST';
export const GET_NEWS = 'GET_NEWS';
export const ADD_NEWS = 'ADD_NEWS';
export const UPDATE_NEWS = 'UPDATE_NEWS';
export const REMOVE_NEWS = 'REMOVE_NEWS';
export const CLEAR_CURRENT_NEWS = 'CLEAR_CURRENT_NEWS';
export const SET_NEWS_FILTER_TYPE = 'SET_NEWS_FILTER_TYPE';
export const SET_NEWS_POSTER_PROPS = 'SET_NEWS_POSTER_PROPS';

//Finance Module
export const GET_FINANCE_LIST = 'GET_FINANCE_LIST'; //list
export const SET_CURRENT_FINANCE = 'SET_CURRENT_FINANCE'; //list
export const ADD_FINANCE = 'ADD_FINANCE'; //add
export const UPDATE_FINANCE = 'UPDATE_FINANCE'; //update
export const DELETE_FINANCE = 'DELETE_FINANCE'; //delete
export const CLEAR_CURRENT_FINANCE = 'CLEAR_CURRENT_FINANCE';
export const SET_FILTER_TYPE_FINANCE = 'SET_FILTER_TYPE_FINANCE ';

// Users Info Module
export const GET_USERS_LIST = 'GET_USERS_LIST';
export const SET_FITER_USER = 'SET_FITER_USER';

// Artist Module
export const GET_ARTISTS_LIST = 'GET_ARTISTS_LIST';
export const GET_ARTIST = 'GET_ARTIST';
export const ADD_ARTIST = 'ADD_ARTIST';
export const EDIT_ARTIST = 'EDIT_ARTIST';
export const DELETE_ARTIST = 'DELETE_ARTIST';
export const SET_ARTIST_FILTER_TYPE = 'SET_ARTIST_FILTER_TYPE';

// Convert & Upload Module
export const GET_CONVERTABLE_LIST = 'GET_CONVERTABLE_LIST';
export const GET_UPLOAD_MOVIE_INFO = 'GET_UPLOAD_MOVIE_INFO';
export const GET_CONVERT_MOVIE_INFO = 'GET_CONVERT_MOVIE_INFO';
export const RQ_CONVERT_MOVIE = 'RQ_CONVERT_MOVIE';
export const PAUSE_CONVERT_MOVIE = 'PAUSE_CONVERT_MOVIE';
export const RQ_COMPANY_TOKEN = 'RQ_COMPANY_TOKEN';
export const RQ_FILE_ID = 'RQ_FILE_ID';
export const SET_FILE_PROPS = 'SET_FILE_PROPS';
export const SET_SUBTITLE_FILE_PROPS = 'SET_SUBTITLE_FILE_PROPS';
export const SET_DUBBED_FILE_PROPS = 'SET_DUBBED_FILE_PROPS';
export const SET_CONVERT_FILTER_TYPE = 'SET_CONVERT_FILTER_TYPE';
export const GET_CONVERTABLE_STATUS = 'GET_CONVERTABLE_STATUS';

// Create & Manage movie
export const GET_MOVIE_INFO = 'GET_MOVIE_INFO';
export const CREATE_MOVIE = 'CREATE_MOVIE';
export const UPDATE_MOVIE = 'UPDATE_MOVIE';
export const DELETE_MOVIE = 'DELETE_MOVIE';
export const GET_PROFESSIONS_LIST = 'GET_PROFESSIONS_LIST';
export const GET_PROFESSION = 'GET_PROFESSION';
export const GET_GENRE = 'GET_GENRE';
export const SET_POSTER_PROPS = 'SET_POSTER_PROPS';
export const UPDATE_POSTER = 'UPDATE_POSTER';
